<script>
export default {
	props: {
		option: Object,
	},
}
</script>

<template>
	<DeliveryOptionCardContent
		v-on="$listeners"
		v-bind="$attrs"
		:option="option"
		:message-items="[
			{ icon: 'mdi-clock', text: this.option.data.openingHours },
			{ icon: 'mdi-phone', text: this.option.data.phone },
			{ icon: 'mdi-email', text: this.option.data.email },
		]"
		show-to-address-line
	/>
</template>
